import React from 'react';
import { Card, Col, Form, Row } from "react-bootstrap";
import "containers/common/Detail.css";
import DatePicker from "react-datepicker";
import "containers/common/List.css";
import "containers/common/Table.css";
import Select from 'react-select';

function QueryGeneralInfo({
    queryData,
    handleChange,
    handleBlur,
    queryTypeOptions,
    user,
    createId,
}) {

    const {
        property_key,
        title_details,
        query_type_code,
        query_type,
        date_to_resolve,
        entered_by,
        problem,
        active,
        doc_number,
        perpetual,
        created_date,
    } = queryData || {};

    const handleSelectChange = (val) => {
        const selectedValue = val?.value || "";
        const selectedLabel = val?.label || "";
        handleChange({
            target: {
                name: "query_type_code",
                value: selectedValue
            }
        });
        handleChange({
            target: {
                name: "query_type",
                value: selectedLabel
            }
        });
        handleBlur();
    };

    const handleCheckboxChange = (e) => {
        handleChange(e);
        handleBlur();
    };

    const handleDateChange = (date, fieldName) => {
        handleChange(date, fieldName);
        handleBlur();
    };

    const handleTextChange = (e) => {
        handleChange(e);
    };

    const handleTextBlur = (e) => {
        handleBlur();
    };

    const selectedQueryType = queryTypeOptions?.find(opt => opt.value === query_type_code) || 
                              { label: query_type, value: query_type_code };

    const resolveId = (...segments) => (typeof createId === "function" ? createId(...segments) : undefined);

    return (
        <Row className="g-3" id={resolveId("general-info", "layout")}>
            <Col sm={12} md={12} lg={3}>
                <Card id={resolveId("panel", "left")} className="h-100">
                    <Card.Body className="d-flex flex-column gap-3">
                        <Form.Group as={Row} className="mb-0">
                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Cityscope Ref.</Form.Label>
                            <Col>
                                <Form.Control
                                    id={resolveId("field", "property-key")}
                                    name="property_key"
                                    onChange={handleTextChange}
                                    value={property_key || ""}
                                    as="input"
                                    type="text"
                                    onBlur={handleTextBlur}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Entered</Form.Label>
                            <Col>
                                <DatePicker
                                    selected={created_date ? new Date(created_date) : null}
                                    onChange={(date) => handleDateChange(date, "created_date")}
                                    dateFormat="dd/MM/yyyy"
                                    onBlur={handleTextBlur}
                                    className="form-control"
                                    id={resolveId("field", "created-date")}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Query Active</Form.Label>
                            <Col className="d-flex align-items-center">
                                <Form.Check
                                    id={resolveId("field", "active")}
                                    checked={!!active}
                                    onChange={handleCheckboxChange}
                                    label=""
                                    type="checkbox"
                                    name="active"
                                    onBlur={handleTextBlur}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date To Resolve</Form.Label>
                            <Col>
                                <DatePicker
                                    selected={date_to_resolve ? new Date(date_to_resolve) : null}
                                    onChange={(date) => handleDateChange(date, "date_to_resolve")}
                                    dateFormat="dd/MM/yyyy"
                                    onBlur={handleTextBlur}
                                    className="form-control"
                                    id={resolveId("field", "date-to-resolve")}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Type</Form.Label>
                            <Col>
                                <Select
                                    inputId={resolveId("field", "query-type")}
                                    value={selectedQueryType}
                                    onChange={handleSelectChange}
                                    options={queryTypeOptions || []}
                                    onBlur={handleTextBlur}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Perpetual</Form.Label>
                            <Col className="d-flex align-items-center">
                                <Form.Check
                                    id={resolveId("field", "perpetual")}
                                    checked={!!perpetual}
                                    onChange={handleCheckboxChange}
                                    label=""
                                    type="checkbox"
                                    name="perpetual"
                                    onBlur={handleTextBlur}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Entered By</Form.Label>
                            <Col>
                                <Form.Control
                                    id={resolveId("field", "entered-by")}
                                    value={entered_by || ""}
                                    as="input"
                                    type="text"
                                    disabled
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-0">
                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Document No.</Form.Label>
                            <Col>
                                <Form.Control
                                    id={resolveId("field", "doc-number")}
                                    name="doc_number"
                                    onChange={handleTextChange}
                                    value={doc_number || ""}
                                    as="input"
                                    type="text"
                                    onBlur={handleTextBlur}
                                />
                            </Col>
                        </Form.Group>
                    </Card.Body>
                </Card>
            </Col>

            <Col sm={12} md={12} lg={6}>
                <div id={resolveId("panel-wrapper", "middle")}>
                    
                    <Card id={resolveId("panel", "middle")} className="h-100">
                        <Card.Body className="d-flex flex-column gap-3">
                            <Form.Label id={resolveId("label", "query-details")} className="text-start mb-2 d-block">Query Details</Form.Label>
                            <Form.Group as={Row} className="mb-0">
                                <Form.Control
                                    id={resolveId("field", "problem")}
                                    name="problem"
                                    onChange={handleTextChange}
                                    value={problem || ""}
                                    as="textarea"
                                    style={{ height: "320px", resize: "none" }}
                                    onBlur={handleTextBlur}
                                />
                            </Form.Group>

                            <Form.Group as={Row} className="mb-0">
                                <Form.Label as={Col} className="text-right" column sm={3}>Title Details</Form.Label>
                                <Col sm={9}>
                                    <Form.Control
                                        id={resolveId("field", "title-details")}
                                        disabled
                                        value={title_details || ""}
                                        as="input"
                                        type="text"
                                    />
                                </Col>
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </div>
            </Col>
        </Row>
    );
}

export default QueryGeneralInfo;